export function fixStoreReview(success_callback, fail_callback) {
    return window.appStoreReview.appStoreReview(success_callback, fail_callback);
}
